export const USER_SET_LOCALE = 'm_USER_SET_LOCALE'
export const USER_SET_PROFILE = 'm_USER_SET_PROFILE'
export const USER_CLEAR_PROFILE = 'm_USER_CLEAR_PROFILE'
export const USER_SET_PROFILE_ABOUT_PRIEST = 'm_USER_SET_PROFILE_ABOUT_PRIEST'
export const USER_SET_COUNTRIES = 'm_USER_SET_COUNTRIES'

export default {
  [USER_SET_LOCALE] (state, locale) {
    state.locale = locale
  },
  [USER_SET_COUNTRIES] (state, countries) {
    state.countries = countries
  },
  [USER_SET_PROFILE] (state, profile) {
    state.id = profile.id
    state.email = profile.email
    state.avatar = profile.avatar
    state.lastname = profile.lastname
    state.firstname = profile.firstname
    state.confirmed = profile.confirmed
    state.priest = profile.priest
    state.parish = profile.parish
    state.parishioner = profile.parishioner
    state.profile = profile.data
    state.balance = profile.balance
    state.locale = profile.locale
  },
  [USER_CLEAR_PROFILE] (state) {
    state.id = ''
    state.email = ''
    state.avatar = ''
    state.lastname = ''
    state.firstname = ''
    state.confirmed = false
    state.priest = false
    state.parish = false
    state.parishioner = false
    state.profile = {
      country: '',
      region: '',
      city: '',
      birthdate: null,
      sex: '',
      skype: '',
      about: ''
    }
    state.balance = []
  },
  [USER_SET_PROFILE_ABOUT_PRIEST] (state, about) {
    state.profile.about = about
  }
}
